import { DeviceWidth } from '../../types.ts';
import { DESKTOP_MAX_WIDTH, PHONE_MAX_WIDTH, TABLET_MAX_WIDTH } from './consts.ts';

export const getDeviceWidthFromWindowWidth = (innerWidth = window.innerWidth): DeviceWidth => {
  if (innerWidth < PHONE_MAX_WIDTH) return 'phone';
  if (innerWidth < TABLET_MAX_WIDTH) return 'tablet';
  if (innerWidth < DESKTOP_MAX_WIDTH) return 'desktop';

  return 'unconstrained';
};
